import { noop } from 'lodash';

import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';
import { CustomToolbar } from '@work4all/components/lib/dataDisplay/actions-bar/ToolbarTypes';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { FSPErrorIndicator } from './FSPErrorIndicator';
import { useFspStatusContext } from './FspStatusContext';
import { FSPWarningIndicator } from './FSPWarningIndicator';

export const useFspCustomActions = (): CustomToolbar => {
  const ctx = useFspStatusContext();
  const warnings = ctx?.result?.data?.fspDiagnostic?.warnings;
  const errors = ctx?.result?.data?.fspDiagnostic?.errors;

  return {
    left: [
      warnings?.length > 0 && {
        actionKey: 'fspDiagnosticWarnings',
        mode: 'Add',
        color: 'secondary',
        handler: noop,
        IconComponent: () => (
          <Tooltip
            title={warnings?.map((msg) => (
              <div>
                {msg}
                <Divider style={{ padding: '0px' }} />
              </div>
            ))}
          >
            <div>
              <FSPWarningIndicator count={warnings?.length} />
            </div>
          </Tooltip>
        ),
      },
      errors?.length > 0 && {
        actionKey: 'fspDiagnosticErrors',
        mode: 'Add',
        handler: noop,
        IconComponent: () => (
          <Tooltip
            title={errors?.map((msg) => (
              <div>
                {msg}
                <Divider style={{ padding: '0px' }} />
              </div>
            ))}
          >
            <div>
              <FSPErrorIndicator count={errors?.length} />
            </div>
          </Tooltip>
        ),
        color: 'secondary',
      },
    ],
  };
};
